export default "/not_correct.2e401dba-6f5a89.png";